// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB8ZEbUWdmrG9QOGx3xI1tiUleUPncP9WM",
  authDomain: "bomander-reviews.firebaseapp.com",
  projectId: "bomander-reviews",
  storageBucket: "bomander-reviews.firebasestorage.app",
  messagingSenderId: "443983445349",
  appId: "1:443983445349:web:2fef689895489d0453358c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);